import React, { useCallback, useContext, useMemo, useState, useRef, useEffect } from 'react';
import { navigateV2, dataSender } from '../../../common/utils/router';
import Form from '../../external_form/ExternalForm';
import UserContext from '../../../common/utils/getContext';
import FormButtons from '../../../widgets/form/form-control-buttons/FormButtons/FormButtons';
import { API_SERVER_URL } from '../../../common/utils/utils';
import { getFormData, getFormFields } from './initData';
import PasswordRecoverTitle from './PasswordRecoverTitle/PasswordRecoverTitle';
import T from '../../../common/components/T';
import css from './PasswordRecover.module.scss';

const PasswordRecover = ({ changePage, message }) => {
    const [complet, setComplet] = useState(false);
    const [usersByEmail, setUsersByEmail] = useState([]);
    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };
    const setFormDataMainFunc = (key, val, setInitValue) => {
        if (typeof val === 'string' && val.length === 0) {
            setInitValue((pre) =>
                Object.keys(pre).reduce((accum, keyFormData) => {
                    if (key !== keyFormData) accum[keyFormData] = pre[keyFormData];
                    return accum;
                }, {})
            );
        } else {
            setInitValue((pre) => {
                return {
                    ...pre,
                    [key]: val
                };
            });
        }
    };
    const [initValue, setInitValue] = useState();

    const setFormDataMain = useCallback((key, val) => {
        setFormDataMainFunc(key, val, setInitValue);
    }, []);

    const data = useMemo(() => getFormFields(usersByEmail), [usersByEmail]);
    const { userToken, setAlertData, lang } = useContext(UserContext);

    const interval = useRef(null);
    useEffect(() => {
        if (initValue?.login && validateEmail(initValue.login)) {
            clearTimeout(interval.current);
            interval.current = setTimeout(() => {
                dataSender(
                    `${API_SERVER_URL}/api/v1/users/check-email`,
                    'POST',
                    {
                        email: initValue?.login
                    },
                    (response) => {
                        if (response?.data?.data?.length > 1) {
                            setUsersByEmail(response?.data?.data);
                        } else {
                            setUsersByEmail([]);
                        }
                    },
                    () => {},
                    userToken,
                    lang
                );
            }, 500);
        }
    }, [userToken, lang, initValue?.login]);

    const [attempts, setAttempts] = useState(0);

    const sender = useCallback(
        (formData, setAllowedSend, setFieldsErr) =>
            getFormData(formData, setAllowedSend, setFieldsErr, userToken, setComplet, setAlertData, lang, message, setAttempts),
        [userToken, setAlertData, lang, message]
    );

    return (
        <>
            <div className={css.passRecoverWrap}>
                <PasswordRecoverTitle complet={complet} />
                {complet && (
                    <FormButtons
                        sendFormData={() => navigateV2('/')}
                        cancelFuncs={{
                            web: {
                                onClick: () => {
                                    setComplet(false);
                                }
                            }
                        }}
                        cancelText={<T textName='back' defaultStr='Назад' page='all' />}
                        buttonText={<T textName='go_main' defaultStr='На главную' page='/authentication' />}
                    />
                )}

                {!complet && (
                    <Form
                        data={{ data }}
                        captcha={{ alias: 'user::password_recovery', attempts }}
                        sendData={{ sender }}
                        setFormDataMain={setFormDataMain}
                        formDataMain={initValue}
                        cancelFuncs={{
                            web: {
                                onClick: () => changePage('login')
                            }
                        }}
                        buttonText={<T textName='go_next' defaultStr='Далее' page='/authentication' />}
                        hoverColor={{
                            hover: 'var(--blueColor)',
                            blur: 'var(--greyDarkColor)'
                        }}
                    />
                )}
            </div>
        </>
    );
};

export default PasswordRecover;
